<template>
                      <h2 class="titleStepForm mb-2">
                        Politically Exposed Persons <sup>(PEPs)</sup>
                      </h2>
                      <p class="subTitleForm text-center">
                        Individuals who are or have been entrusted with prominent
                        functions by an international/ local organization such as:
                      </p>
                      <div class="formContentPoli mb-3">
                        <h3 class="font-size-22 mb-4 mt-5 text-center">
                          Please tick the one(s) that apply
                        </h3>
                        <p>
                          A <strong>“politically exposed person”</strong> (PEP)
                          means a person who is or was entrusted with a prominent
                          function by an international/ local organization or
                          important political functions such as:
                        </p>
                        <h5>International Organization:</h5>
                        <p>
                          Members of senior management such as directors and
                          members of the board or equivalent function. United
                          Nations and affiliated international organizations,
                          Organization of America States, Inter-American
                          Development Bank, International Labour Organization, and
                          Caribbean Financial Action Task Force.
                        </p>
                        <h5>Government:</h5>
                        <p>
                          Head of State, senior politician, senior government
                          official, judicial or military officials, and senior
                          executives of State owned corporations and important
                          political party officials. Senior government officials-
                          e.g. Permanent Secretary, Accounting Officer, Chief
                          Technical Officer, High Commissioner Senior executives
                          of state corporations e.g. Board members of all
                          Statutory Bodies. Senior political party officials e.g.
                          Chairman, Deputy Chairman, Secretary and Treasurer,
                          Judicial Official e.g. Judges, magistrates, Military
                          Officials e.g. a Lieutenant Colonel or higher rank.
                        </p>
                        <p>
                          An immediate family member or any individual publicly
                          known or actually known to the relevant financial
                          institution to be associated with a PEP.
                        </p>
                        <p>Are you or have you ever been:</p>
                      </div>
                      <div class="groupFormStyle">
                        <div class="mb-3">
                          <h3 class="font-size-15">
                            (a) Entrusted with a prominent function referred to
                            above
                          </h3>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="yesEntrust"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.entrustedRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal5.entrustedRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesEntrust"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noEntrust"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.entrustedRadio.$error,
                                }"
                              >
                                <template v-if="isEdit">
                                <input
                                  type="radio"
                                  v-model="form.personal5.entrustedRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noEntrust"
                                  :checked="true"
                                />
                                </template>
                                <template v-if="!isEdit">
                                <input
                                  type="radio"
                                  v-model="form.personal5.entrustedRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noEntrust"
                                />
                                </template>
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal5.entrustedRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal5.entrustedRadio.$errors[0]">{{ v$.form.personal5.entrustedRadio.$errors[0].$message }}</span></div>
  </div>
                        </div>
                        <div class="mb-3">
                          <h3 class="font-size-15">
                            (b) an immediate family member of a person referred to
                            above (a) such as the spouse, parent, siblings,
                            children and children of the spouse of that person;
                          </h3>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="yesMember"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.memberOfRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal5.memberOfRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesMember"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noMember"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.memberOfRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal5.memberOfRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noMember"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal5.memberOfRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal5.memberOfRadio.$errors[0]">{{ v$.form.personal5.memberOfRadio.$errors[0].$message }}</span></div>
  </div>
                        </div>
                        <div class="mb-3">
                          <h3 class="font-size-15">
                            (C) a close personal or professional associate of the
                            persons referred to above (a) or (b)
                          </h3>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="yesReferred"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.referredRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal5.referredRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesReferred"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noReferred"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal5.referredRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal5.referredRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noReferred"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal5.referredRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal5.referredRadio.$errors[0]">{{ v$.form.personal5.referredRadio.$errors[0].$message }}</span></div>
  </div>
                        </div>
                        <div class="border-top pt-3">
                          <h4 class="text-center font-size-14 mb-0">
                            If you have answered “yes” to any of the questions
                            above, Enhanced Due Diligence Form to be completed
                          </h4>
                        </div>
                      </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "PepStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["form"],
    validate: true,
    }),
  ],
};
</script>
